export default "__VITE_ASSET__hjiwSzmF__"